import BotCampaign from './BotCampaign'

export default BotCampaign
